/**
 * Fix for live search input event listener
 * Simple approach: trigger keyup event on input/paste since keyup already works
 */
(function() {
  'use strict';
  
  // Debounce function
  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
  
  // Fix a single input element
  function fixInput(inputElement) {
    if (!inputElement || inputElement._inputFixApplied) return false;
    
    // Wait for jQuery if not ready
    if (typeof jQuery === 'undefined') {
      return false;
    }
    
    // Mark as fixed
    inputElement._inputFixApplied = true;
    
    const $ = jQuery;
    const $input = $(inputElement);
    
    // Since keyup works, let's trigger keyup event on input/paste
    const triggerKeyup = debounce(function() {
      // Create a synthetic keyup event and trigger it
      const keyupEvent = $.Event('keyup.live-search', {
        key: 'Input',
        keyCode: 0,
        which: 0,
        target: inputElement,
        currentTarget: inputElement
      });
      $input.trigger(keyupEvent);
    }, 250);
    
    // Add native event listeners with immediate execution
    const handleInput = function() {
      triggerKeyup();
    };
    
    inputElement.addEventListener('input', handleInput, { capture: true, passive: true });
    inputElement.addEventListener('paste', function() {
      setTimeout(handleInput, 50);
    }, { capture: true, passive: true });
    inputElement.addEventListener('cut', function() {
      setTimeout(handleInput, 50);
    }, { capture: true, passive: true });
    
    // Also monitor value changes as fallback (more frequent)
    let lastValue = inputElement.value || '';
    const valueCheck = setInterval(function() {
      const currentValue = inputElement.value || '';
      if (currentValue !== lastValue) {
        lastValue = currentValue;
        handleInput();
      }
    }, 200);
    
    // Store for cleanup
    inputElement._inputFixInterval = valueCheck;
    inputElement._inputFixHandler = handleInput;
    
    return true;
  }
  
  // Fix all inputs
  function fixAllInputs() {
    const inputs = document.querySelectorAll('[data-live-search-input]');
    let fixed = 0;
    inputs.forEach(function(input) {
      if (fixInput(input)) {
        fixed++;
      }
    });
    return fixed;
  }
  
  // Wait for jQuery and Theme to be ready
  function waitForDependencies(callback) {
    if (typeof jQuery !== 'undefined' && window.Theme) {
      callback();
    } else {
      setTimeout(() => waitForDependencies(callback), 100);
    }
  }
  
  // Initialize
  function init() {
    waitForDependencies(function() {
      // Try multiple times to catch inputs as they're added
      let attempts = 0;
      const maxAttempts = 10;
      
      function tryFix() {
        const fixed = fixAllInputs();
        attempts++;
        
        if (fixed === 0 && attempts < maxAttempts) {
          setTimeout(tryFix, 500);
        }
      }
      
      tryFix();
    });
  }
  
  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Watch for dynamically added inputs
  if (window.MutationObserver) {
    const observer = new MutationObserver(function(mutations) {
      let hasNewInputs = false;
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            if (node.matches && node.matches('[data-live-search-input]')) {
              hasNewInputs = true;
            } else if (node.querySelector && node.querySelector('[data-live-search-input]')) {
              hasNewInputs = true;
            }
          }
        });
      });
      if (hasNewInputs) {
        setTimeout(fixAllInputs, 100);
      }
    });
    
    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    } else {
      setTimeout(function() {
        if (document.body) {
          observer.observe(document.body, {
            childList: true,
            subtree: true
          });
        }
      }, 100);
    }
  }
})();

